import { Button, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Brand } from 'src/app/api/openapi';
import { GridColDef } from '@mui/x-data-grid-premium';
import { useMemo, useRef } from 'react';
import { ReadOnlyClient } from 'src/app/api/clients/readonly';
import CustomDataGrid from 'src/app/components/CustomDataGrid';

const Brands = () => {
  const navigate = useNavigate();

  const cursor = useRef<string | undefined>(undefined);

  const dataSource = useMemo(
    () => ({
      getRows: () =>
        ReadOnlyClient.readOnlyListBrands(
          'name',
          null,
          20,
          cursor.current
        ).then(({ data }) => {
          cursor.current = data.cursor;
          return {
            rows: data?.items || [],
          };
        }),
    }),
    []
  );

  const columns: GridColDef<Brand>[] = [
    {
      headerName: 'Name',
      field: 'name',
      flex: 1,
    },
    {
      headerName: 'ID',
      field: 'id',
      width: 225,
    },
  ];

  return (
    <>
      <Stack direction="row" justifyContent="space-between">
        <Typography variant="h1">Brands</Typography>
        <Button
          variant="flat"
          onClick={() => navigate('/organizations?create=brands')}
        >
          Create Brand
        </Button>
      </Stack>
      <Stack maxHeight="80vh">
        <CustomDataGrid
          dataSource={dataSource}
          columns={columns}
          rowCount={-1}
          lazyLoading
          lazyLoadingRequestThrottleMs={500}
          paginationModel={{ page: 0, pageSize: 10 }}
        />
      </Stack>
    </>
  );
};

export default Brands;
